import React from "react";
import ToggleSwitch from "./ToggleSwitch";

const Setting = ({ name, on, sound, save }) => {
  return (
    <label
      style={{ cursor: "pointer" }}
      onMouseUp={() => {
        // sound();
        save();
      }}
    >
      <div>{name}</div>
      <ToggleSwitch name={name} isOn={on} />
    </label>
  );
};
export default Setting;
